import React from 'react';
import PropTypes from 'prop-types';

import SvgSymbol from 'common/components/svg-symbol';

export default class ListItem extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    data: PropTypes.object,
    su: PropTypes.bool,
    superpartner: PropTypes.bool,
  };

  static defaultProps = {
    su: false,
    superpartner: false,
  };

  static makeItemList(dataArray, keyName = '') {
    return dataArray.map((listItemProps, index) => (
      <ListItem {...listItemProps} key={`${keyName}-ListItem-${index}`} />
    ));
  }

  getClassName() {
    const className = this.props.data && this.props.data.className;
    return className ? `ListItem ${className}` : 'ListItem';
  }

  getContents() {
    if (this.props.children) {
      return this.props.children;
    }

    const {href, text, dataset, su, superpartner} = this.props.data;

    return href ? (
      <a href={href} {...dataset}>
        {text}
        {su ? <SvgSymbol name={'lock'} /> : null}
        {superpartner ? <div className="fa-superpartner"/> : null}
      </a>
    ) : (
      text
    );
  }

  render() {
    return <li className={this.getClassName()}>{this.getContents()}</li>;
  }
}
